import { render, staticRenderFns } from "./confirm-modal.vue?vue&type=template&id=3c738c94&scoped=true&"
import script from "./confirm-modal.vue?vue&type=script&lang=js&"
export * from "./confirm-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c738c94",
  null
  
)

export default component.exports